import { useContext } from "react";
import { GalleryContext } from "../contexts";

const useGallery = () => {
  return useContext(GalleryContext);
};

export default useGallery;
